import { render } from "./trade_reward.vue?vue&type=template&id=a546055c"
import script from "./trade_reward.vue?vue&type=script&lang=js"
export * from "./trade_reward.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__